module.exports = __webpack_public_path__ + "img/flowers-card-60.4f653776.jpg";